import { Injectable } from '@angular/core';
import { ProviderData } from '../models/provider';

@Injectable({
  providedIn: 'root'
})
export class ProviderStateService {

  private readonly providerIdKey = 'providerId';
  private readonly isPrimaryProviderKey = 'isPrimaryProvider';
  private readonly logoUrlKey = 'logoUrl';
  private readonly slugKey = 'slug';
  private readonly name = 'name';


  constructor() { }

  setProviderData(providerData: ProviderData) {
   
    localStorage.setItem(this.providerIdKey, providerData.providerId);
    localStorage.setItem(this.isPrimaryProviderKey, JSON.stringify(providerData.isPrimaryProvider)); // Convert boolean to string
    localStorage.setItem(this.logoUrlKey, providerData.logoUrl);
    localStorage.setItem(this.slugKey, providerData.slug);
    localStorage.setItem(this.name, providerData.name);
  }

  getProviderData(): ProviderData {
    const providerId = localStorage.getItem(this.providerIdKey);
    const isPrimaryProvider = localStorage.getItem(this.isPrimaryProviderKey);
    const logoUrl = localStorage.getItem(this.logoUrlKey);
    const slug = localStorage.getItem(this.slugKey);
    const name = localStorage.getItem(this.name);
    if (providerId && isPrimaryProvider && logoUrl && slug && name) {
      return {
        providerId: providerId,
        isPrimaryProvider: JSON.parse(isPrimaryProvider),
        logoUrl: logoUrl,
        slug: slug,
        name: name
      };
    }
    return null;
  }

  clearProviderData() {
    
    localStorage.removeItem(this.providerIdKey);
    localStorage.removeItem(this.isPrimaryProviderKey);
    localStorage.removeItem(this.logoUrlKey);
    localStorage.removeItem(this.slugKey);
    localStorage.removeItem(this.name);
  }

  getProviderId() {
    return localStorage.getItem(this.providerIdKey);
  }

  getProviderSlug() {
    return localStorage.getItem(this.slugKey);
  }

  getProviderName() {
    return localStorage.getItem(this.name);
  }

  getIsPrimaryProvider() {
    const isPrimaryProvider = localStorage.getItem(this.isPrimaryProviderKey);
    return isPrimaryProvider ? JSON.parse(isPrimaryProvider) : false;
  }

  getLogoUrl() {
    return localStorage.getItem(this.logoUrlKey);
  }

  setLogoUrl(logoUrl: string) {
    localStorage.setItem(this.logoUrlKey, logoUrl);
  }
}
